<template>
    <div class="cont_after">
        <div class="box_after box1 animate__animated animate__slideInLeft">
            <h1>{{ $t('offer.first_after_create_title') }}</h1>
            <p>{{ $t('offer.first_after_create_desc') }}</p>
            <img src="/img/menu/FirstLoginAfterDogo1.svg" alt="">
            <a href="/admin/offers/create" class="btn_after btn1">
                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0.5C7.26522 0.5 7.51957 0.605357 7.70711 0.792893C7.89464 0.98043 8 1.23478 8 1.5V6.5H13C13.2652 6.5 13.5196 6.60536 13.7071 6.79289C13.8946 6.98043 14 7.23478 14 7.5C14 7.76522 13.8946 8.01957 13.7071 8.20711C13.5196 8.39464 13.2652 8.5 13 8.5H8V13.5C8 13.7652 7.89464 14.0196 7.70711 14.2071C7.51957 14.3946 7.26522 14.5 7 14.5C6.73478 14.5 6.48043 14.3946 6.29289 14.2071C6.10536 14.0196 6 13.7652 6 13.5V8.5H1C0.734784 8.5 0.48043 8.39464 0.292893 8.20711C0.105357 8.01957 0 7.76522 0 7.5C0 7.23478 0.105357 6.98043 0.292893 6.79289C0.48043 6.60536 0.734784 6.5 1 6.5H6V1.5C6 1.23478 6.10536 0.98043 6.29289 0.792893C6.48043 0.605357 6.73478 0.5 7 0.5Z" fill="white"/>
                </svg>
                {{ $t('offer.first_after_create_btn') }}
            </a>
        </div>
        <div class="box_after box2 animate__animated animate__slideInDown" >
            <h1>{{ $t('offer.first_after_setup_title') }}</h1>
            <p>{{ $t('offer.first_after_setup_desc') }}</p>
            <img src="/img/menu/FirstLoginAfterDogo2.svg" alt="">
            <a href="/admin/nastavenia/firma-a-kontakty" class="btn_after btn2">
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.34101 1.353C8.99901 -0.050997 7.00101 -0.050997 6.65901 1.353C6.60795 1.56398 6.5078 1.75992 6.36671 1.92487C6.22562 2.08983 6.04757 2.21915 5.84707 2.3023C5.64656 2.38545 5.42925 2.42008 5.21283 2.40338C4.99641 2.38669 4.78699 2.31913 4.60161 2.2062C3.36681 1.4538 1.95381 2.8668 2.70621 4.1016C3.19221 4.899 2.76111 5.9394 1.85391 6.1599C0.449007 6.501 0.449007 8.4999 1.85391 8.8401C2.06494 8.89123 2.26091 8.99147 2.42587 9.13267C2.59082 9.27387 2.7201 9.45203 2.80317 9.65264C2.88624 9.85326 2.92076 10.0707 2.90391 10.2871C2.88706 10.5036 2.81932 10.7131 2.70621 10.8984C1.95381 12.1332 3.36681 13.5462 4.60161 12.7938C4.78695 12.6807 4.99639 12.613 5.21287 12.5961C5.42935 12.5793 5.64675 12.6138 5.84737 12.6968C6.04799 12.7799 6.22615 12.9092 6.36734 13.0741C6.50854 13.2391 6.60878 13.4351 6.65991 13.6461C7.00101 15.051 8.99991 15.051 9.34011 13.6461C9.39141 13.4352 9.49174 13.2393 9.63297 13.0745C9.7742 12.9097 9.95233 12.7805 10.1529 12.6974C10.3534 12.6144 10.5708 12.5798 10.7872 12.5966C11.0036 12.6133 11.213 12.6809 11.3984 12.7938C12.6332 13.5462 14.0462 12.1332 13.2938 10.8984C13.1809 10.713 13.1133 10.5036 13.0966 10.2872C13.0798 10.0708 13.1144 9.85344 13.1974 9.65288C13.2805 9.45233 13.4097 9.2742 13.5745 9.13297C13.7393 8.99174 13.9352 8.8914 14.1461 8.8401C15.551 8.499 15.551 6.5001 14.1461 6.1599C13.9351 6.10878 13.7391 6.00854 13.5741 5.86734C13.4092 5.72614 13.2799 5.54798 13.1968 5.34736C13.1138 5.14675 13.0793 4.92935 13.0961 4.71287C13.113 4.49639 13.1807 4.28695 13.2938 4.1016C14.0462 2.8668 12.6332 1.4538 11.3984 2.2062C11.2131 2.31932 11.0036 2.38706 10.7871 2.40391C10.5707 2.42076 10.3533 2.38624 10.1526 2.30317C9.95203 2.2201 9.77387 2.09082 9.63267 1.92586C9.49147 1.76091 9.39123 1.56493 9.34011 1.3539L9.34101 1.353ZM8.00001 10.2C8.71609 10.2 9.40285 9.91554 9.9092 9.40919C10.4155 8.90284 10.7 8.21609 10.7 7.5C10.7 6.78392 10.4155 6.09716 9.9092 5.59082C9.40285 5.08447 8.71609 4.8 8.00001 4.8C7.28392 4.8 6.59717 5.08447 6.09082 5.59082C5.58447 6.09716 5.30001 6.78392 5.30001 7.5C5.30001 8.21609 5.58447 8.90284 6.09082 9.40919C6.59717 9.91554 7.28392 10.2 8.00001 10.2Z" fill="white" fill-opacity="0.16"/>
                </svg>
                {{ $t('offer.first_after_setup_btn') }}
            </a>
        </div>
        <div class="box_after box3 animate__animated animate__slideInRight">
            <h1>Potrebujem pomoc</h1>
            <p>{{ $t('offer.first_after_help') }} <a href="mailto:david@doffero.com">david@doffero.com</a></p>
            <img src="/img/menu/FirstLoginAfterDogo3.svg" alt="">
            <!-- <a class="btn_after btn3" onclick="smartsupp('chat:open'); return false;"> -->
            <a class="btn_after btn3" href="mailto:david@doffero.com">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.4248 3.90083C15.4121 5.17087 16.0312 6.76674 16.0312 8.49996C16.0312 10.2331 15.4121 11.8291 14.4248 13.0991" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/><path d="M13.0991 14.4248C11.8291 15.412 10.2332 16.0312 8.5 16.0312C6.76682 16.0312 5.17091 15.412 3.90088 14.4248" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/><path d="M2.57519 13.0991C1.58791 11.829 0.96875 10.2332 0.96875 8.49995C0.96875 6.76676 1.58791 5.17086 2.57519 3.90083" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/><path d="M3.90088 2.57515C5.17091 1.58787 6.76678 0.968712 8.5 0.968712C10.2332 0.968712 11.8291 1.58787 13.0991 2.57515" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/><path d="M8.5 12.25C6.43228 12.25 4.75 10.5677 4.75 8.49995C4.75 6.43224 6.43228 4.74995 8.5 4.74995C10.5677 4.74995 12.25 6.43224 12.25 8.49995C12.25 10.5677 10.5677 12.25 8.5 12.25Z" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/><path d="M5.27025 6.59592L2.53407 3.85974C2.17166 3.4973 2.168 2.90605 2.53 2.54324C2.53441 2.53883 2.53885 2.53439 2.54329 2.52999C2.9061 2.16796 3.49735 2.17161 3.85975 2.53405L6.59594 5.27024" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/><path d="M6.59594 11.7297L3.85975 14.4659C3.49735 14.8283 2.9061 14.8319 2.54329 14.4699C2.53885 14.4655 2.53441 14.4611 2.53 14.4567C2.168 14.0939 2.17166 13.5026 2.53407 13.1402L5.27025 10.404" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/><path d="M10.4041 5.27024L13.1403 2.53406C13.5027 2.17162 14.0939 2.16796 14.4567 2.52996C14.4611 2.5344 14.4656 2.53884 14.47 2.54324C14.832 2.90606 14.8284 3.49731 14.4659 3.85971L11.7297 6.59593" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/><path d="M11.7297 10.404L14.4659 13.1402C14.8283 13.5026 14.832 14.0939 14.4699 14.4567C14.4655 14.4611 14.4611 14.4655 14.4567 14.4699C14.0939 14.832 13.5026 14.8283 13.1402 14.4659L10.404 11.7297" stroke="#9FADBC" stroke-width="0.849609" stroke-miterlimit="10"/>
                </svg>
                Pomoc
            </a>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="scss" scoped>
.cont_after{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 63px;
    padding-bottom: 50px;
    @media only screen and (max-width: 860px) {
        display: block;
        width: 270px;
        margin: 0 auto;
    }
    .box1{
        background: #212541;
        h1,p{
            color: #FFFFFF;
        }
    }
    .box2,.box3{
        background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #2ED8B6;
        h1{
            color: #212541;
        }
        p{
            color: #9598A7;
        }
    }
    .box3{
        margin-right: 0;
    }
    .box_after{
        width: 270px;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        position: relative;
        padding: 39px 27px 0 28px;
        margin-right: 17px;
        height: 405px;
        max-height: 405px;
        @media only screen and (max-width: 860px) {
            margin-right: 0;
            margin-top: 50px;
        }
        h1{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 21px;
        }
        p{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 130%;
            margin-bottom: 35px;
            a{
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                color: #1F78FF;  
                text-decoration: underline;
            }
        }
        img{
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
        }
        .btn_after{
            width: 219px;
            height: 55px;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;

            position: absolute;
            bottom: -23px;
            left: 50%;
            transform: translate(-50%, 0);
            cursor: pointer;
            transition: .2s;
            text-decoration: none;

            svg{
                margin-right: 10px;
            }
        }
        .btn1{
            background: #2ED8B6;
            color: #FFFFFF;
            &:hover{
                background: #23a58b;
            }
        }
        .btn2{
            background: #212541;
            color: #FFFFFF;
            &:hover{
                background: #121424;
            }
        }
        .btn3{
            background: #DAE1E8;
            color: #212541;
            &:hover{
                background: #c8cdd1;
            }
        }
        
    
    }
}
</style>